/** The card's width, per the Experience Drivers Figma cards. */
export const INFO_CARD_WIDTH = 500;

/** Long enough for the pointer to cross the gap between the target and the card, e.g. to reach a footer button. */
export const INFO_CARD_CLOSE_DELAY_MS = 300;

/** The body scrolls past this height, per the Figma annotation. */
export const INFO_CARD_BODY_MAX_HEIGHT = 630;
